module.exports = __webpack_public_path__ + "static/media/up-arrow.d1135a61.svg";